import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './set_role.component.html'
})
export class SetRoleModalComponent extends BaseSupportModalComponent {
	title: string;
	userId: string;
	admin: boolean;
	accessor: boolean;
	role: string;

	async ok() {
		if (confirm(`Вы уверены, что хотите назначить роль аккаунту: ${this.title}?`)) {
			await this.supportService.setRole(this.userId, this.role, this.admin, this.accessor, this.spreader.base.comment).toPromise();

			this.execute();
		}
	}
}
